import { authPaths } from '@/shared/lib/routing/auth'
import { sendToNative } from '@/shared/lib/native-bridge/send'
import { NativeBridgeEvents } from '@/shared/lib/native-bridge/types'

import type { Navigate } from './types'

const fallbackNavigate: Navigate = (url: string) => {
  if (typeof window !== 'undefined') window.location.replace(url)
}

export function executeRequireAuth(
  inNativeAppWebView: boolean,
  callbackUrl?: string,
  navigate: Navigate = fallbackNavigate
): void {
  const callback = callbackUrl ?? '/'

  if (inNativeAppWebView) {
    sendToNative({ type: NativeBridgeEvents.AUTH_REQUIRED, callbackUrl: callback })
    return
  }

  navigate(authPaths.signIn({ callbackUrl: callback }))
}
